import $ from 'jquery';

export default function initSiteBackground() {
    $(function() {
        const $window = $(window);
        const $document = $(document);
        if($document.width() >= 1024) {
            const $parallaxScrollingBackgrounds = $(".site-background.parallax-scrolling");
            if($parallaxScrollingBackgrounds.length > 0) {
                $window.on("scroll", function() {
                    //console.log($(this).scrollTop());
                    const scrollTop = $window.scrollTop();
                    $parallaxScrollingBackgrounds.each(function() {
                        const $parallaxScrollingBackground = $(this);
                        //console.log($document.width());
                        if($document.width() >= 1024) {
                            let parallaxScrollSpeed = $parallaxScrollingBackground.data("parallax-scroll-speed");
                            if(parallaxScrollSpeed) {
                                parallaxScrollSpeed = parseFloat(parallaxScrollSpeed);
                            }
                            else {
                                parallaxScrollSpeed = 0.5;
                            }
                            $parallaxScrollingBackground.css("top", (scrollTop * parallaxScrollSpeed) + "px");
                        }
                        else {
                            $parallaxScrollingBackground.css("top", "");
                        }
                    });
                });
            }
        }
    })
};
